// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"386":"6b4c73a0","421":"b7953cf2","619":"9969c94d","642":"9969c94d"}[chunkId] + ".css";
};